import { Trash2 } from "lucide-react"

const CommentReply = ({ reply, onDeleteComment }) => {

    return (
        <div className="flex gap-3 ml-12 mb-3 justify-between" >
            <div className="flex gap-3"> 
                <img
                    src={reply.user?.profileImage || `https://ui-avatars.com/api/?name=${reply.user?.fullName}&background=random`}
                    alt={reply.user?.fullName}
                    className="w-8 h-8 mt-4 rounded-full flex-shrink-0"
                />
                <div className="flex-1">
                    <div className="bg-gray-50 rounded-2xl px-4 py-3">
                        <div className="flex items-center gap-2 mb-1">
                            <span className="font-semibold text-sm text-gray-900">{reply.user?.fullName}</span>
                            {reply.user?.isExpert && (
                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">Expert</span>
                            )}
                            <span className="text-xs text-gray-500">
                                {new Date(reply.createdAt).toLocaleDateString()}
                            </span>
                        </div>
                        <p className="text-sm text-gray-700">{reply.text}</p>
                    </div>
                    <div className="flex items-center gap-4 mt-2 ml-4">
                        <span className="text-xs text-gray-500">{reply.totalLikes} likes</span>
                    </div>
                </div>
            </div>
            <Trash2 className="text-red-500 mx-4 mt-2 cursor-pointer h-5 w-5" onClick={() => onDeleteComment(reply?._id)} />
        </div>
    )
}


export default CommentReply